import { render, staticRenderFns } from "./DiscountCreateEditModal.vue?vue&type=template&id=2f6e6fd4&scoped=true&"
import script from "./DiscountCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./DiscountCreateEditModal.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCreateEditModal.vue?vue&type=style&index=0&id=2f6e6fd4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6e6fd4",
  null
  
)

export default component.exports